import { createContext } from 'react';
export var formContext = /*#__PURE__*/createContext({
  state: 'loading',
  token: {
    publicKey: 'wrong-key'
  },
  fieldConfigs: undefined
});
var throwWrapWithCreditCardFormState = function throwWrapWithCreditCardFormState() {
  throw new Error('Please wrap with CreditCardFormState');
};
export var formStateContext = /*#__PURE__*/createContext([{}, throwWrapWithCreditCardFormState]);
export var formErrorContext = /*#__PURE__*/createContext([undefined, function () {
  throw new Error('Please wrap with CreditCardFormState');
}]);
export var formStateRefs = /*#__PURE__*/createContext([{}, throwWrapWithCreditCardFormState]);
export var retryContext = /*#__PURE__*/createContext(throwWrapWithCreditCardFormState);